<mat-tab-group (selectedTabChange)="onChange($event)" #tabGroup class="edi-tabs-wrapper" mat-stretch-tabs="false"
  mat-align-tabs="start" [selectedIndex]="0">
  <mat-tab label="EDI Orders Search" style="width: 25%;">
    <div class="edi-search-tab-container">
      <div id="ediorders-main-wraper">
        <div class="col-12 search-ft p-0 mt-3">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label name="lblEdiOrdersPOSrch" class="control-label">PO Number</label>
                <input type="text" class="form-control" name="txtEdiOrdersPOSrch" [(ngModel)]="txtEdiOrdersPOSrch"
                  maxlength="30" tabindex="1" (keydown.enter)="onKeyEnter()">
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label name="lblEdiOrdersUNSrch" class="control-label">Unit Number</label>
                <input type="text" class="form-control" name="txtEdiOrdersUNSrch" [(ngModel)]="txtEdiOrdersUNSrch"
                  maxlength="12" tabindex="2" (keydown.enter)="onKeyEnter()">
              </div>
            </div>
            <div class="col-sm-3 d-inline-flex p-0">
              <div class="col d-flex align-items-start">
                <div class="form-group">
                  <button class="btn btn-primary mr-2" name="btnEdiOrdersSrch" tabindex="3"
                    (click)="getGridDataOnSearch()">Search</button>
                  <button class="btn btn-outline-primary mr-2" name="btnEdiOrdersReset" (click)="resetFilters()"
                    tabindex="4">Reset</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edi-search-grid-wrapper">
        <ag-grid-angular #agGridEdiOrders [enableCellTextSelection]="true"
          class="ag-theme-material edi-search-grid-layout" [rowData]="rowData" [columnDefs]="columnDefs"
          [gridOptions]="gridOptions" tabindex="5">
        </ag-grid-angular>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="EDI Orders Priority" style="width: 25%;">
    <div class="priority-tab-container">
      <div id="ediorders-main-wraper">
        <div class="col-12 search-ft p-0 mt-3">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label name="lblPEdiOrdersUNSrch" class="control-label">PO / Order / Machine</label>
                <input type="text" class="form-control" name="txtPriEdiOrdersSrch" [(ngModel)]="txtPriEdiOrdersSrch"
                  maxlength="20" tabindex="6" (keydown.enter)="onPriorityKeyEnter()">
              </div>
            </div>
            <div class="col-sm-3 d-inline-flex p-0">
              <div class="col d-flex align-items-start">
                <div class="form-group">
                  <button class="btn btn-primary mr-2" name="btnPriEdiOrdSrch" tabindex="7"
                    (click)="getFilteredSortedGrid()">Search</button>
                  <button class="btn btn-outline-primary mr-2" name="btnPEdiOrdersReset" (click)="resetPFilters()"
                    tabindex="8">Reset</button>
                </div>
              </div>
            </div>
            <div id="gridActions" class="col-6 d-flex align-items-end">
              <label class="mr-10" name="lblPRUpload" (click)="open(uploadModal)" tabindex="9"><span>
                  <em class="fas fa-file-upload"></em></span> Upload</label>&nbsp;&nbsp;
              <label class="mr-2" name="lblPRExport" (click)="exportExcel()" tabindex="10"><span>
                  <em class="fas fa-file-download"></em></span> Export</label>
            </div>
          </div>
        </div>
      </div>
      <div class="priority-grid-wrapper">
        <ag-grid-angular #agPGridEdiOrders [enableCellTextSelection]="true"
          class="ag-theme-material priority-grid-layout" [rowData]="PriorityRowData" [columnDefs]="columnPDefs"
          [gridOptions]="priorityGridOptions" tabindex="11">
        </ag-grid-angular>
      </div>
      <div class="priority-footer clearfix">
        <div class="divfloatleft">
          <label name="lblCount" class="control-label lblCountAlign">No.of Records :{{ lblEdiOrderCount }}</label>
        </div>
        <div class="divfloatright">
          <button class="btn btn-primary mr-2" name="btnSave" (click)="btnPrioritySave()">Save</button>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Spare Parts" style="width: 25%;">
    <div class="spareparts-tab-container">
      <div id="spareparts-main-wraper">
        <div class="col-12 search-ft p-0 mt-3">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label name="lblSparePartsSrch" class="control-label">PO / Order / Branch</label>
                <input type="text" class="form-control" name="txtSparePartsSrch" [(ngModel)]="txtSparePartsSrch"
                  maxlength="20" tabindex="12" (keydown.enter)="onSparePartsKeyEnter()">
              </div>
            </div>
            <div class="col-sm-3 d-inline-flex p-0">
              <div class="col d-flex align-items-start">
                <div class="form-group">
                  <button class="btn btn-primary mr-2" name="btnSparePartsSrch" tabindex="13"
                    (click)="getSparePartsGridDataOnSearch()">Search</button>
                  <button class="btn btn-outline-primary mr-2" name="btnSPReset" (click)="resetSPFilters()"
                    tabindex="14">Reset</button>
                </div>
              </div>
            </div>
            <div id="gridActions" class="col-6 d-flex align-items-end">
              <label class="mr-2" name="lblAddSP" (click)="open(addSparePartsModal)" tabindex="15"><span><em
                    class="fas fa-plus-circle"></em></span> Add Spare Part</label>
              <label *ngIf="isRowSelected" class="mr-2" name="lblSelSaveSP" (click)="open(sparePartsModal)"
                tabindex="16"><span><em class="fas fa-save"></em></span> Save Spare Parts</label>
              <label *ngIf="!isRowSelected" class="mr-2" name="lblSaveSP" title="Select the record to save Spare Parts"
                tabindex="15"><span> <em class="fas fa-save"></em></span> Save Spare
                Parts</label>
              <label class="mr-2" name="lblSPExport" (click)="sparePartsExportExcel()" tabindex="17"><span>
                  <em class="fas fa-file-download"></em></span> Export</label>
            </div>
          </div>
        </div>
      </div>
      <div class="spareparts-grid-wrapper">
        <ag-grid-angular #agSPGrid [enableCellTextSelection]="true" class="ag-theme-material spareparts-grid-layout"
          [rowData]="filteredSparePartsLoadData" [columnDefs]="columnSPDefs" [gridOptions]="sparePartsGridOptions"
          tabindex="17" (rowSelected)="onRowSelected($event)">
        </ag-grid-angular>
      </div>
    </div>
  </mat-tab>
  <mat-tab></mat-tab>
</mat-tab-group>


<!--Template to upload excel file-->
<ng-template #uploadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">File Upload</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalClose()">
      <em class="fas fa-times-circle"></em>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12 search-ft p-2 mt-3">
      <div class="col-12">
        <div class="form-group">
          <input type="file" title="Choose a file" id="fileUpload" name="fileUpload"
            accept=".xml, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            (change)="handleFileInput($event.target.files)">
        </div>
        <div class="lblerror">
          {{ this.excelUnitTypeError }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary mr-2" (click)="onFileUpload()">Upload</button>
    <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose()">Cancel</button>
  </div>
</ng-template>

<ng-template #sparePartsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Spare Parts</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalClose()">
      <em class="fas fa-times-circle"></em>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12 search-ft p-0 mt-0">
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label name="lblPONumber" class="control-label">PO Number: {{ poNumber }}
            </label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label name="lblONumber" class="control-label">Order Number: {{ orderNumber }}
            </label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label name="lblbranch" class="control-label">Branch: {{ branch }}
            </label>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          CPIB2 Gateway &nbsp;
          <mat-slide-toggle id="toogle1" class="example-margin" [(ngModel)]="gatewayUpdateEnable"
            (change)="gatewayChange($event)">
          </mat-slide-toggle>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label name="lblGWMLType" class="control-label required">Type :
                </label>
                <select [disabled]="!gatewayUpdateEnable" name="ddGWMLType" class="form-control"
                  (change)="gatewayTypeSelectChanged($event)">
                  <option *ngFor="let type of gatewayTypes" [selected]="type.id === gatewayTypeSelectedId"
                    [value]="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>
              <div class="lblerror" *ngIf="lblErrorGWMLType">
                {{ this.lblErrorGWMLType }}
              </div>
            </div>
            <div class="col">

              <div class="form-group">
                <label name="lblGWMlMacAdd" class="control-label required">Gateway Mac Address</label>
                <input [disabled]="!gatewayUpdateEnable" type="text" class="form-control" name="txtGWMlMacAdd"
                  [(ngModel)]="txtGWMlMacAdd" maxlength="20" />
              </div>
              <div class="lblerror" *ngIf="lblErrorGWMLMacAdd">
                {{ this.lblErrorGWMLMacAdd }}
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label name="lblGWPwd" class="control-label">Gateway Password </label>
                <input [disabled]="!gatewayUpdateEnable" type="password" class="form-control" name="txtGWPwd"
                  [(ngModel)]="txtGWPwd" maxlength="20" />
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="card">
        <div class="card-header">
          Gateway SIM Card &nbsp;
          <mat-slide-toggle id="toogle2" class="example-margin" [(ngModel)]="gatewaySimCardEnable"
            (change)="gatewaySimCardChange($event)">
          </mat-slide-toggle>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label name="lblGWMlIccId" class="control-label">SIM Card ICCID1 : AT&T</label>
                <input [disabled]="!gatewaySimCardEnable" type="text" class="form-control" name="txtGWMlIccId"
                  onblur="clearErrorMessages()" [(ngModel)]="txtGWMlIccId" maxlength="30" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label name="lblGWMlIccId2" class="control-label">SIM Card ICCID2 : Verizon</label>
                <input [disabled]="!gatewaySimCardEnable" type="text" class="form-control" name="txtGWMlIccId2"
                  onblur="clearErrorMessages()" [(ngModel)]="txtGWMlIccId2" maxlength="30" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <div class="lblerror" *ngIf="lblErrorGSimCard">
                  {{ this.lblErrorGSimCard }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          ePAL Gateway &nbsp;
          <mat-slide-toggle id="toogle3" class="example-margin" [ngModel]="ePALgatewayUpdateEnable"
            (change)="epalGatewayChange($event)">
          </mat-slide-toggle>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label name="lblGWDeviceMLType" class="control-label required">Device Gateway Type
                </label>
                <select [disabled]="!ePALgatewayUpdateEnable" name="ddGWDeviceMLType"
                  [(ngModel)]="devicegatewayTypeSelId" class="form-control">
                  <option *ngFor="let type of Devicegateway" [value]="type.id"
                    [selected]="type.id === devicegatewayTypeSelId">
                    {{ type.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label name="lblEGWMLType" class="control-label required">Gateway Type
                </label>
                <select [disabled]="!ePALgatewayUpdateEnable" name="ddEGWMLType" class="form-control"
                  (change)="egatewayTypeSelectChanged($event)">
                  <option *ngFor="let type of gatewayTypes" [value]="type.id"
                    [selected]="type.id === eGatewayTypeSelectedId">
                    {{ type.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label name="lblEGWMlMacAdd" class="control-label required">Gateway Mac Address</label>
                <input [disabled]="!ePALgatewayUpdateEnable" type="text" class="form-control" name="txtEGWMlMacAdd"
                  [(ngModel)]="txtEGWMlMacAdd" maxlength="20" />
              </div>
              <div class="lblerror" *ngIf="lblErrorEGWMLMacAdd">
                {{ this.lblErrorEGWMLMacAdd }}
              </div>
            </div>
            <div class="col">
              <label name="lblGWPwd" class="control-label">Gateway Password </label>
              <input [disabled]="!ePALgatewayUpdateEnable" type="password" class="form-control" name="txtEGWPwd"
                [(ngModel)]="txtEGWPwd" maxlength="20" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        ePAL Gateway SIM Card &nbsp;
        <mat-slide-toggle id="toogle4" class="example-margin" [ngModel]="ePALgatewaySimCardEnable"
          (change)="epalSimCardChange($event)">
        </mat-slide-toggle>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label name="lblEGWMlIccId" class="control-label">SIM Card ICCID1 : AT&T</label>
              <input [disabled]="!ePALgatewaySimCardEnable" type="text" class="form-control" name="txtEGWMlIccId"
                onblur="clearErrorMessages()" [(ngModel)]="txtEGWMlIccId" maxlength="30" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label name="lblEGWMlIccId2" class="control-label">SIM Card ICCID2 : Verizon</label>
              <input [disabled]="!ePALgatewaySimCardEnable" type="text" class="form-control" name="txtEGWMlIccId2"
                onblur="clearErrorMessages()" [(ngModel)]="txtEGWMlIccId2" maxlength="30" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div class="lblerror" *ngIf="lblErrorEGSimCard">
                {{ this.lblErrorEGSimCard }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        ePAL &nbsp;
        <mat-slide-toggle id="toogle5" class="example-margin" [ngModel]="ePALDeviceEnable"
          (change)="epalDeviceChange($event)">
        </mat-slide-toggle>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label name="lblepalUUID" class="control-label required">ePAL UUID</label>
              <input [disabled]="!ePALDeviceEnable" type="text" class="form-control" name="txtePalUUID"
                [(ngModel)]="txtePalUUID" maxlength="30" />
            </div>
            <div class="lblerror" *ngIf="lblErrorEUUID">
              {{ this.lblErrorEUUID }}
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label name="lbleSerialNumber" class="control-label required">EloView Serial Number</label>
              <input [disabled]="!ePALDeviceEnable" type="text" class="form-control" name="txteSerailNumber"
                [(ngModel)]="txteSerailNumber" maxlength="30" />
            </div>
            <div class="lblerror" *ngIf="lblErrorESerialNumber">
              {{ this.lblErrorESerialNumber }}
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label name="lblAppContent" class="control-label required">Device Application
                Type</label>
              <select [disabled]="!ePALDeviceEnable" name="ddAppContent" class="form-control" tabindex="7"
                (change)="onContentSelectChanged($event)">
                <option value="0" selected>--- Select ---</option>
                <option *ngFor="let content of appContent" [selected]="content.contentId === appContentSelectedId"
                  [value]="content.contentId">
                  {{ content.applicationName }}
                </option>
              </select>
            </div>
            <div class="lblerror" *ngIf="lblErrorDevAppType">
              {{ this.lblErrorDevAppType }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary mr-2" (click)="onSaveSpareParts($event)"
      [disabled]="(enableDisableSavebtn)">
      Save
    </button>
    <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose()">
      Close
    </button>
  </div>
</ng-template>
<ng-template #addSparePartsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Add Spare Part</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalClose()">
      <em class="fas fa-times-circle"></em>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12 search-ft p-0 mt-0">
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label name="lblPONumber" class="control-label">PO Number: {{ addPONumber }}
            </label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label name="lblONumber" class="control-label">Order Number: {{ addOrderNumber }}
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label name="lblAddBranch" class="control-label required">Branch
            </label>
            <input type="text" class="form-control" name="txtBranch" [(ngModel)]="txtBranch" maxlength="16" tabindex="1"/>
          </div>
          <div class="lblerror" *ngIf="lblErrorBranch">
            {{ this.lblErrorBranch }}
          </div>
        </div>
        <div class="col">

          <div class="form-group">
            <label name="lblAddShipperName" class="control-label required">Shipper Name</label>
            <input type="text" class="form-control" name="txtShipperName" [(ngModel)]="txtShipperName" maxlength="32" tabindex="2"/>
          </div>
          <div class="lblerror" *ngIf="lblErrorShipperName">
            {{ this.lblErrorShipperName }}
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label name="lblAddShipperPhone" class="control-label required">Shipper Phone</label>
            <input type="text" class="form-control" name="txtShipperPhone" [(ngModel)]="txtShipperPhone"
              maxlength="16" tabindex="3"/>
          </div>
          <div class="lblerror" *ngIf="lblErrorShipperPhone">
            {{ this.lblErrorShipperPhone }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label name="lblAddUnitNumber" class="control-label required">Unit Number
            </label>
            <input type="text" class="form-control" name="txtUnitNumber" [(ngModel)]="txtUnitNumber" maxlength="10" tabindex="4"/>
          </div>
          <div class="lblerror" *ngIf="lblErrorUnitNumber">
            {{ this.lblErrorUnitNumber }}
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label name="lblAddPartNumber" class="control-label required">Part Number</label>
            <select name="ddPartNumber" class="form-control"
            (change)="partNumberChanged($event)" tabindex="5">
                <option value="0" selected>--- Select ---</option>
                <option *ngFor="let part of partNumbers" 
                  [value]="part.partId">
                  {{ part.partNumber }}
                </option>
              </select>
               <div class="lblerror" *ngIf="lblErrorPartNumber">
              {{ this.lblErrorPartNumber }}
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
             <label name="lblAddJobSite" class="control-label">Job Site</label>
            <input type="text" class="form-control" name="txtJobSite" [(ngModel)]="txtJobSite" maxlength="32" tabindex="6"/>           
          </div>
        </div>
      </div>
      <div class="row">        
        <div class="col">
          <div class="form-group">
            <label name="lblAddBldgAddress" class="control-label">Building Address
            </label>
            <textarea class="form-control" name="txtBuildingAddress" [(ngModel)]="txtBuildingAddress" maxlength="128" tabindex="7"></textarea>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label name="lblAddNotes" class="control-label">Notes</label>
            <textarea class="form-control" name="txtNotes" [(ngModel)]="txtNotes" maxlength="258" tabindex="8"></textarea>
          </div>
        </div>
        <div class="col">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary mr-2" (click)="onAddSpareParts($event)" tabindex="9">
      Save
    </button>
    <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose()" tabindex="10">
      Close
    </button>
  </div>
</ng-template>